export default __webpack_public_path__ + "static/media/tbd.4bc37e79.webp";